// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B8vX","right":"styles_right__2sAe0"};